import { StatusDot } from '../../../components';
import { exposureStatusColor } from '../utils';

export default function ExposureStatusDot({ exposure }) {
  const statusColor = exposureStatusColor(exposure?.status);
  return <StatusDot color={statusColor} />;
}
